import { useEffect, useMemo, useState } from 'react';

import { StudentSectionSettingTypeCodes } from 'const';
import { useAppSelector } from 'hooks';
import {
  studentPrimaryNavigation,
  studentSecondaryNavigation,
} from 'portfolio3/components/common/PortfolioNavigation/const';
import { ISectionNavigationLink } from 'portfolio3/components/common/PortfolioNavigation/types';
import { configSelector, linkVisibilitySettingsSelector, visibilitySettingsSelector } from 'selectors';
import { findTargetVisibilitySetting } from 'utils/localVisibilitySettingsService';

const useVisibleNavigation = () => {
  const linkMode = useAppSelector((state) => state.linkMode.mode) ?? false;
  const linkVisibilitySettings = useAppSelector((state) => linkVisibilitySettingsSelector(state));
  const visibilitySettings = useAppSelector((state) => visibilitySettingsSelector(state));
  const config = useAppSelector(configSelector);
  const hideCulture = config?.HIDE_CULTURE === true;

  const mappedVisibilitySettings = useMemo(() => {
    return linkMode ? linkVisibilitySettings : visibilitySettings;
  }, [linkMode, linkVisibilitySettings, visibilitySettings]);

  const filteredStudentPrimaryNavigation = useMemo(() => {
    return studentPrimaryNavigation.filter((nav) => {
      if (hideCulture && nav.sectionTypeCode === StudentSectionSettingTypeCodes.culture) {
        return false;
      }

      return true;
    });
  }, [hideCulture]);
  const [primaryNavigation, setPrimaryNavigation] = useState<ISectionNavigationLink[]>(
    filteredStudentPrimaryNavigation,
  );
  const [secondaryNavigation, setSecondaryNavigation] = useState<ISectionNavigationLink[]>(studentSecondaryNavigation);

  useEffect(() => {
    const primaryNavigation = filteredStudentPrimaryNavigation.filter((navigation) => {
      return findTargetVisibilitySetting(mappedVisibilitySettings, [navigation.sectionTypeCode])?.computedVisibility;
    });
    const secondaryNavigation = studentSecondaryNavigation.filter((navigation) => {
      return findTargetVisibilitySetting(mappedVisibilitySettings, [navigation.sectionTypeCode])?.computedVisibility;
    });

    setPrimaryNavigation(primaryNavigation);
    setSecondaryNavigation(secondaryNavigation);
  }, [mappedVisibilitySettings, filteredStudentPrimaryNavigation]);

  return {
    primaryNavigation,
    secondaryNavigation,
  };
};

export default useVisibleNavigation;
